export default {
  text: 'Fez uma encomenda há menos de 15 minutos! Confirme se deseja prosseguir com esta nova encomenda ou gerir a existente.',
  buttons: {
    see_existing_order: 'Ver encomenda existente',
    proceed_new_order: 'Prosseguir nova encomenda',
  },
};
